import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
    selector: 'app-tema',
    templateUrl: './tema.component.html',
    styleUrls: ['./tema.component.scss']
})
export class TemaComponent {
    public message: string;

    // constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    //             @Inject(MAT_DIALOG_DATA) public data: any) {
    //     this.message = data.message;
    // }

    constructor(
        public dialogRef: MatDialogRef<TemaComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.message = data.message;
    }
}
